    <!--#region bouton de sauveagerde-->
    <div class="row">
      <div class="col-12">
        <button id="ImportBtn" class="q-btn q-main" (click)="Save(storage == '' ? newClient : updateClient)">
          <i [ngClass]="[isSaving ? 'fas fa-pulse fa-spin fa-spinner' : 'fas fa-save']"></i>
        </button>
      </div>
    </div>
    <!--#endregion-->

    <ng-container *ngIf="!loadingModal">

      <!--#region client existant-->
      <div class="row mt-2">
        <div class="col-12">
          <fieldset class="q-fieldset">
            <legend class="col-auto">Client existant dans MCF</legend>
            <div class="row">
              <!--#region nom du groupe-->
              <div class="col-12">
                <label class="col-auto">Nom du groupe</label>
                <select class="q-main-select col-auto" [ngModel]="group" (ngModelChange)="group = $event; GetStorageList();GetStorageDatas('')">
                  <option *ngFor="let group of ListGroup" [value]="group.Id">{{group.Name}}</option>
                </select>
              </div>
              <!--#endregion-->
              <!--#region nom du dossier-->
              <div class="col-12">
                <label class="col-auto">Nom du dossier client</label>
                <select class="q-main-select col-auto" [(ngModel)]="storage" (ngModelChange)="GetStorageDatas($event)">
                  <option *ngFor="let storage of storageList" [value]="storage.Id">{{storage.Name}}</option>
                </select>
              </div>
              <!--#endregion-->
              <ng-container *ngIf="storage != '' && listsLoadedOnUpdate">
                <ng-container *ngTemplateOutlet="lists;context:{disabled:storage != '', collabs:collabsList, selectedCollabs:selectedCollabsList, contacts:contactsList, selectedContacts:selectedContactsList, arbos:ListArbos, selectedArbos: selectedArbosList, props:lstProps ,selectedProps:lstSelectedProps, client:updateClient}">
                </ng-container>
              </ng-container>
            </div>
          </fieldset>
        </div>
      </div>
      <!--#endregion-->

      <!--#region nouveau client--> 
      <div class="row mt-2" *ngIf="storage == ''">
        <div class="col-12">
          <fieldset class="q-fieldset" [ngClass]="{'q-light-grey' : storage != ''}">
            <legend class="col-auto" [ngClass]="{'q-dark-main' : storage != ''}">Créer un nouveau client dans MCF</legend>

            <div class="row">
              <!--#region nom du client-->
              <div class="col-12">
                <label class="col-auto">Nom du client</label>
                <input type="text" class="col-auto q-input-border"
                       [required]="storage == ''"
                       [disabled]="storage != ''"
                       [(ngModel)]="clientName" />
              </div>
              <!--#endregion-->
              <!--#region nom du groupe-->
              <div class="col-12">
                <label class="col-auto">Nom du groupe</label>
                <select class="q-main-select col-auto"
                        [(ngModel)]="selectedGroup"
                        [required]="storage == ''"
                        [disabled]="storage != ''">
                  <option *ngFor="let group of ListGroup" [value]="group.Id">{{group.Name}}</option>
                </select>
              </div>
              <!--#endregion-->
              <ng-container *ngTemplateOutlet="lists;context:{disabled:storage != '', collabs:collabsList, selectedCollabs:[], contacts:contactsList, selectedContacts:[], arbos:ListArbos, selectedArbos: [], props:lstProps ,selectedProps:lstSelectedProps, client:newClient}">
              </ng-container>
            
            </div>
          </fieldset>
        </div>
      </div>
      <!--#endregion-->

    </ng-container>

    <ng-template #lists let-disabled="disabled"
                 let-collabs="collabs" let-selectedCollabs="selectedCollabs"
                 let-contacts="contacts" let-selectedContacts="selectedContacts"
                 let-arbos="arbos" let-selectedArbos="selectedArbos"
                 let-props="props" let-selectedProps="selectedProps"
                 let-client="client">
      <!--#region collaborateurs-->
      <div *ngIf="collabs && selectedCollabs && (collabs.length > 0 || selectedCollabs.length > 0)" class="col-xl-6 mb-2 position-relative">
        <!--s'affiche si liste non vide-->
        <!--se filtre et se tri sur 'LastName' et 'FirstName'-->
        <q-select-multiple [disabled]="disabled"
                           elementsColumName='Collaborateurs MCF'
                           selectedElementsColumName="Collaborateur MCF accédants au dossier du client (si vide, alors tout le monde aura accès)"
                           [elementsList]="collabs"
                           [filterableProperties]="filterableProperties"
                           [SortablesProperties]="filterableProperties"
                           [selectedElementsList]="selectedCollabs"
                           (selectChange)="OnCollabsListChange($event, client)">
          <!--#region template pour la liste des éléments non sélectionnés-->
          <!--affiche nom prenom (email) sur la ligne et le title-->
          <ng-template let-collab #elementList>
            <div class="col-auto pl-1 p-0"
                 style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: calc(100% - 19px);"
                 title="{{collab.LastName}} {{collab.FirstName}} ({{collab.Email}})">{{collab.LastName}} {{collab.FirstName}} ({{collab.Email}})</div>
          </ng-template>
          <!--#endregion-->
          <!--#region template pour la liste des éléments sélectionnés-->
          <!--affiche nom prenom (email) sur la ligne et le title-->
          <ng-template let-collab #elementSelected>
            <div class="col-auto pl-1 p-0"
                 style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: calc(100% - 19px);"
                 title="{{collab.LastName}} {{collab.FirstName}} ({{collab.Email}})">{{collab.LastName}} {{collab.FirstName}} ({{collab.Email}})</div>
          </ng-template>
          <!--#endregion-->
        </q-select-multiple>
      </div>
      <!--#endregion-->
      <!--#region contacts-->
      <div *ngIf="contacts && selectedContacts && (contacts.length > 0 || selectedContacts.length > 0)" class="col-xl-6 mb-2 position-relative">
        <!--s'affiche si liste non vide-->
        <!--se filtre et se tri sur 'LastName' et 'FirstName'-->
        <q-select-multiple [disabled]="disabled"
                           elementsColumName="Contacts Client"
                           selectedElementsColumName="Contacts clients accédants au dossier"
                           [elementsList]="contacts"
                           [filterableProperties]="filterableProperties"
                           [SortablesProperties]="filterableProperties"
                           [selectedElementsList]="selectedContacts"
                           (selectChange)="OnContactListChange($event, client)">
          <!--#region template pour la liste des éléments non sélectionnés-->
          <!--affiche nom prenom (email) sur la ligne et le title-->
          <ng-template let-contact #elementList>
            <div class="col-auto pl-1 p-0"
                 style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: calc(100% - 19px);"
                 title="{{contact.LastName}} {{contact.FirstName}} ({{contact.Email}})">{{contact.LastName}} {{contact.FirstName}} ({{contact.Email}})</div>
          </ng-template>
          <!--#endregion-->
          <!--#region template pour la liste des éléments sélectionnés-->
          <!--affiche nom prenom (email) sur la ligne et le title-->
          <!--ajoute en fin de ligne un bouton pour définir si oui ou non on envoi un email d'activation de compte my company files-->
          <ng-template let-contact let-index="index" #elementSelected>
            <div class="col-auto pl-1 p-0"
                 style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: calc(100% - 55px);"
                 title="{{contact.LastName}} {{contact.FirstName}} ({{contact.Email}})">{{contact.LastName}} {{contact.FirstName}} ({{contact.Email}})</div>
            <!--#region bouton envoi mail ou non-->
            <div class="col-auto pl-1 p-0" *ngIf="!disabled">
              <input id="checkbox-{{contact.Email}}" type="checkbox" name="sendMailContact" [(ngModel)]="contact.SendMail" class="d-none" />
              <label for="checkbox-{{contact.Email}}" class="q-pointer mb-0" title="envoyer un email d'activation du compte">
                <span class="fa-stack" style="vertical-align: top;">
                  <i class="fas fa-paper-plane fa-stack-1x" [ngClass]="[contact.SendMail ? 'q-c-main' : 'q-c-black']"></i>
                  <i *ngIf="!contact.SendMail" class="fas fa-times fa-stack-1x q-c-danger" style="text-shadow: 0 0 0px #fff "></i>
                </span>
              </label>
            </div>
            <!--#endregion-->
          </ng-template>
          <!--#endregion-->
        </q-select-multiple>
      </div>
      <!--#endregion-->
      <!--#region arborescences-->
      <div *ngIf="arbos && selectedArbos && (arbos.length > 0 || selectedArbos.length > 0)" class="col-xl-6 mb-2 position-relative">
        <!--s'affiche si liste non vide-->
        <!--ne se filtre pas et se tri sur 'Name'-->
        <q-select-multiple [disabled]="disabled"
                           elementsColumName="Modèles d'arborescences"
                           selectedElementsColumName="Modèles sélectionnés"
                           [elementsList]="arbos"
                           [SortablesProperties]="['Name']"
                           [selectedElementsList]="selectedArbos"
                           (selectChange)="OnArboListChange($event, client)">
          <!--#region template pour la liste des éléments non sélectionnés-->
          <!--affiche le nom du modèle d'arborescence my company files-->
          <ng-template let-arbo #elementList>
            <div class="col-auto pl-1 p-0">{{arbo.Name}}</div>
          </ng-template>
          <!--#endregion-->
          <!--#region template pour la liste des éléments sélectionnés-->
          <!--affiche le nom du modèle d'arborescence my company files-->
          <ng-template let-arbo #elementSelected>
            <div class="col-auto pl-1 p-0">{{arbo.Name}}</div>
          </ng-template>
          <!--#endregion-->
        </q-select-multiple>
      </div>
      <!--#endregion-->
      <!--#region propriétés-->
      <div *ngIf="selectedProps" class="col-xl-6 mb-2 position-relative">
        <!--s'affiche si liste non vide-->
        <!--se filtre et se tri sur 'LastName' et 'FirstName'-->
        <q-select-multiple #SelectMultipleProps [disabled]="disabled"
                           elementsColumName="Propriétés"
                           selectedElementsColumName="Sélectionnées"
                           [elementsList]="props"
                           [filterableProperties]="['Value']"
                           [SortablesProperties]="['Value']"
                           [selectedElementsList]="selectedProps"
                           (selectChange)="OnPropChange($event)">
          <!--#region template pour la liste des éléments non sélectionnés-->
          <!--affiche nom prenom (email) sur la ligne et le title-->
          <ng-template let-prop #elementList>
            <div class="col-auto pl-1 p-0"
                 style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: calc(100% - 19px);"
                 title="{{prop.Value}}">{{prop.Value}}</div>
          </ng-template>
          <!--#endregion-->
          <!--#region template pour la liste des éléments sélectionnés-->
          <!--affiche nom prenom (email) sur la ligne et le title-->
          <!--ajoute en fin de ligne un bouton pour définir si oui ou non on envoi un email d'activation de compte my company files-->
          <ng-template let-prop let-index="index" #elementSelected>
            <div class="col-auto pl-1 p-0"
                 style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: calc(100% - 55px);"
                 title="{{selectedProps[index].Value}}">{{selectedProps[index].Value}}</div>
            <!--#region bouton envoi mail ou non-->
            <div class="col-auto pl-1 p-0">
              <input type="text" list="datalist-props" [(ngModel)]="selectedProps[index].Name" class="col q-input-border my-0" [disabled]="disabled"/>
            </div>
            <!--#endregion-->
          </ng-template>
          <!--#endregion-->
        </q-select-multiple>
      </div>
      <!--#endregion-->
    </ng-template>

    <!--#region loader-->
    <ng-container *ngIf="loadingModal">
      <div class="row justify-content-center">
        <div class="col-auto m-3">
          <i class="fas fa-spin fa-spinner fa-pulse q-c-main fa-5x"></i>
        </div>
      </div>
    </ng-container>
    <!--#endregion-->

  <datalist id="datalist-props">
    <option value="CodeClient">
    <option value="Siret">
    <option value="Activité">
    <option value="Adresse">
    <option value="Ville">
    <option value="Code Postal">
    <option value="Régime TVA">
    <option value="Date de TVA">
    <option value="Forme Juridique">
    <option value="Mission sociale">
    <option value="Régime fiscal">
  </datalist>
